import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { ROUTES } from '../../constants/Routes';
import { useSelector } from 'react-redux';

const NoLoginRoute = () => {
  const state = useSelector((state) => state);
  const accessToken = state.authenReducer.accessToken;
  // //console.log("accessToken", accessToken)
  if (accessToken) {
    return <Navigate replace to={ROUTES.Home} />;
  }
  return <Outlet />;
};

export default NoLoginRoute;
